import { Action as BaseAction } from '@ngrx/store';
import {
  LoginParams,
  LoginResponse,
  LogoutResponse,
  CheckSessionParams,
  CheckSessionResponse,
} from '../../services/auth/interface';

export enum ActionTypes {
  Login = 'Auth.Login',
  LoginSuccess = 'Auth.LoginSuccess',
  LoginFailure = 'Auth.LoginFailure',
  Logout = 'Auth.Logout',
  LogoutSuccess = 'Auth.LogoutSuccess',
  LogoutFailure = 'Auth.LogoutFailure',
  ResolveSession = 'Auth.ResolveSession',
  ResolveSessionSuccess = 'Auth.ResolveSessionSuccess',
  ResolveSessionFailure = 'Auth.ResolveSessionFailure',
}

export type Action =
  | Login
  | LoginSuccess
  | LoginFailure
  | Logout
  | LogoutSuccess
  | LogoutFailure
  | ResolveSession
  | ResolveSessionSuccess
  | ResolveSessionFailure;

// =============================================================================
// Load UserInfo
// =============================================================================

export type LoginPayload = LoginParams;
export type LoginSuccessPayload = LoginResponse;
export type LogoutSuccessPayload = LogoutResponse;
export type ResolveSessionPayload = CheckSessionParams;
export type ResolveSessionSuccessPayload = CheckSessionResponse;

export class Login implements BaseAction {
  readonly type = ActionTypes.Login;
  constructor(public payload: LoginPayload) {}
}

export class LoginSuccess implements BaseAction {
  readonly type = ActionTypes.LoginSuccess;
  constructor(public payload: LoginSuccessPayload) {}
}

export class LoginFailure implements BaseAction {
  readonly type = ActionTypes.LoginFailure;
  constructor(public error: any) {}
}

export class Logout implements BaseAction {
  readonly type = ActionTypes.Logout;
  constructor() {}
}

export class LogoutSuccess implements BaseAction {
  readonly type = ActionTypes.LogoutSuccess;
  constructor(public payload: LogoutSuccessPayload) {}
}

export class LogoutFailure implements BaseAction {
  readonly type = ActionTypes.LogoutFailure;
  constructor(public error: any) {}
}

export class ResolveSession implements BaseAction {
  readonly type = ActionTypes.ResolveSession;
  constructor(public payload: ResolveSessionPayload) {}
}

export class ResolveSessionSuccess implements BaseAction {
  readonly type = ActionTypes.ResolveSessionSuccess;
  constructor(public payload: ResolveSessionSuccessPayload) {}
}

export class ResolveSessionFailure implements BaseAction {
  readonly type = ActionTypes.ResolveSessionFailure;
  constructor(public error: Error) {}
}
